import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=6b2383f2&"
import script from "./Issues.vue?vue&type=script&lang=js&"
export * from "./Issues.vue?vue&type=script&lang=js&"
import style0 from "./Issues.vue?vue&type=style&index=0&id=6b2383f2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2383f2')) {
      api.createRecord('6b2383f2', component.options)
    } else {
      api.reload('6b2383f2', component.options)
    }
    module.hot.accept("./Issues.vue?vue&type=template&id=6b2383f2&", function () {
      api.rerender('6b2383f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/Issues.vue"
export default component.exports